import React from "react";
import "./experience.css";
import { BsPatchCheckFill } from "react-icons/bs";
import { frontEndExperiences, backEndExperiences } from "./data.js";

const Experience = () => {
  return (
    <section id="experience">
      <h5>What Skills I Have</h5>
      <h2>My Experience</h2>

      <div className="container experience__container">
        <div className="experience__frontend">
          <div className="experience__title">
            <h3>Frontend Development</h3>
          </div>
          <div className="experience__content">
            {frontEndExperiences.map((experience) => (
              <article className="experience__details" key={experience.id}>
                <BsPatchCheckFill className="experience__details-icon" />
                <div className="experience__details-text">
                  <h4>{experience.name}</h4>
                  <small className="text-light">{experience.level}</small>
                </div>
              </article>
            ))}
          </div>
        </div>
        <div className="experience__backend">
          <h3>Backend Development</h3>
          <div className="experience__content">
            {backEndExperiences.map((experience) => (
              <article className="experience__details" key={experience.id}>
                <BsPatchCheckFill className="experience__details-icon" />
                <div className="experience__details-text">
                  <h4>{experience.name}</h4>
                  <small className="text-light">{experience.level}</small>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Experience;
